<template>
	<div>
		<div class="modal fade" id="CatModal" data-backdrop="static">
			<div class="modal-dialog" role="document">
				<!--
				=================================================================================================================
													CREATE PASSAPORT MODAL!
				=================================================================================================================
			-->

				<div class="modal-content" style="width: 30%; margin: 0 auto">
					<div class="modal-header">
						<button
							type="button"
							class="close"
							data-dismiss="modal"
							aria-label="Close"
						>
							<span aria-hidden="true">&times;</span>
						</button>
						<h4 class="modal-title" id="myModalLabel">
							PRONTUARIO DE Passaporte DOF
						</h4>
					</div>
					<!-- <div class="modal-body" v-if="!this.data.creationCPF"> -->
					<div class="modal-body">
						<div class="col-sm-12">
							<span>Nome</span>
							<input
								type="text"
								v-model="data.nome"
								class="form-control"
							/>
						</div>

						<div class="col-sm-12">
							<span>PASSAPORT</span>
							<input
								type="text"
								v-model="data.passaport"
								class="form-control"
							/>
						</div>

						<div class="col-sm-12">
							<span>NAVIO</span>
							<div class="add-more-section">
								<select
									v-model="data.navio"
									class="form-control"
									value="data.navio"
								>
									<option
										v-for="(navio, index) in this.navios"
										:key="index"
										:value="navio.navio"
									>
										{{ navio.navio }}
									</option>
								</select>
								<!--
						<aBtn
						@click='handleToggleCreationShip()'
						text='' icon='plus' size='sm' type='success'
						/>
						-->
							</div>
						</div>

						<div class="clearfix"></div>
						<br />
					</div>
					<div class="modal-footer">
						<div class="modal-footer__buttons">
							<button
								type="button"
								class="btn btn-default"
								data-dismiss="modal"
							>
								<i class="fa fa-close"></i> Cancelar
							</button>

							<aBtn
								action="private-save-exams"
								@click="save"
								text="Salvar"
								icon="save"
								type="primary"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	/*

	id precisa existir para poder ocorrer a criação

	*/
	import clone from 'js/clone';
	import aBox from 'box';
	import aBtn from 'btn';
	import WBS from 'js/http';
	import toastr from 'toastr';
	import axios from 'axios';
	import moment from 'moment';

	let reset = {
		nome: '',
		passaport: '',
		nome_tipo_exame: '',
	};

	export default {
		name: 'ChModalPassaporte',
		components: { aBox, aBtn },
		data() {
			return {
				data: clone(reset),
				test: null,
				pessoas: [],
				navios: [],
			};
		},
		methods: {
			open(data = null) {
				if (data != null) this.data = clone(data);
				else this.data = clone(reset);
				$('#CatModal').modal('show');
			},
			save() {
				WBS.send('private-save-passaport', this.data, (resp) => {
					if (resp.status == 'success') {
						toastr.success('Registro alterado com sucesso!');
						this.$emit('update');
						$('#CatModal').modal('hide');
					} else {
						toastr.error(resp.msgs[0]);
						console.log(resp);
						console.log(this.data);
					}
				});
			},

			handleLoadNavios() {
				const testParms = {
					pager: {
						page: '0',
						qnt: '50',
					},
					// filter: `cpf=${cpf}`
				};

				WBS.send('private-read-navios', testParms, (resp) => {
					this.navios = resp.data.table;
					console.log(resp.data.table.length);
					const lastNavio = this.navios[this.navios.length - 1];
					this.data.navio = lastNavio.navio;

					console.log(lastNavio.navio);

					console.log(resp.data.table);
				});
			},

			onSelectState() {
				axios
					.get(
						`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${this.data.estado}/municipios?orderBy=nome`
					)
					.then((response) => (this.municipios = response.data));
			},
		},

		mounted() {
			axios
				.get(
					'https://servicodados.ibge.gov.br/api/v1/localidades/estados?orderBy=nome'
				)
				.then((response) => (this.estados = response.data));

			this.handleLoadNavios();
		},
	};
</script>

<style>
	span {
		text-transform: uppercase;
	}

	.modal-dialog {
		width: 80% !important;
	}

	.modal-footer__buttons {
		display: flex;
		justify-content: space-between;
	}

	.add-more-section {
		display: flex;
	}
</style>



// WEBPACK FOOTER //
// src/components/cadastros/passaport/modal.vue